module.exports = __webpack_public_path__ + "img/deng.d13d10ac.png";